module.exports = __webpack_public_path__ + "20aaf9b15edcd8eb06555ad970d697be.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/img/HJ_logo.jpg
// module id = 580
// module chunks = 0